export const UPSTACK_TEMPLATE_NAME = 'Upstack Default Template';
export const OVERVIEW_VIEW_NAME = 'Overview';
export const SUMMARY_VIEW_NAME = 'Summary';
